export function createPathHelper(args: any, exportVariables: any) {
  const variables = { ...args, ...exportVariables }
  const qs = Object.keys(variables).reduce((acc: string, key: string): string => {
    if (variables[key] === null || variables[key] === undefined) {
      return acc
    }
    if (variables[key] instanceof Array) {
      let array = ''
      for (const entry of variables[key]) {
        let connector = '&'
        if (acc === '' && array === '') {
          connector = '?'
        }
        array = array + connector + key + '=' + encodeURIComponent(String(entry))
      }
      return acc + array
    }
    if (acc === '') {
      return '?' + key + '=' + encodeURIComponent(String(variables[key]))
    }
    return acc + '&' + key + '=' + encodeURIComponent(String(variables[key]))
  }, '')
  return qs
}
